import angular from 'angular';
import uiRouter from 'angular-ui-router';
import RegistryComponent from './registry.component';

let RegistryModule = angular.module('Registry', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newRegistry', {
            url: '/registries/new',
            component: 'registry',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editRegistry', {
            url: '/registries/:id',
            component: 'registry',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                registry: (
                    RegistriesService,
                    $stateParams
                ) =>  RegistriesService.findById($stateParams.id)
            }
        });
})
.component('registry', RegistryComponent)
.name;

export default RegistryModule;
